import * as React from "react";
import StudentTag from "../../../../domains/StudentTag";
import OperatorInterface from "../../../../interfaces/OperatorInterface";
import SectionInterface from "../../../../interfaces/SectionInterface";
import { ActiveOperator } from "../../../../interfaces/SectionOperatorsInterface";
import OperatorTableRow from "./OperatorTableRow";
import styles from "./styles.scss";

interface Props {
  section: SectionInterface;
  currentOperator: OperatorInterface;
  sectionTags: StudentTag[];
  activeOperators: ActiveOperator[];
}

const ActiveOperatorList: React.FC<Props> = (props) => {
  if (!props.activeOperators || props.activeOperators.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.label}>アクティブスタッフ</div>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableHeader}>
              <th>氏名</th>
              <th>メールアドレス</th>
              <th>権限</th>
              <th>閲覧制限タグ</th>
              <th>Zoom連携</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.activeOperators.map((operator) => (
              <OperatorTableRow
                key={operator.id}
                operator={operator}
                sectionId={props.section.id}
                sectionName={props.section.fullName}
                currentOperatorId={props.currentOperator.id}
                sectionTags={props.sectionTags}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActiveOperatorList;
